module.exports = __webpack_public_path__ + "static/media/Nse.4892e618.svg";